import React from 'react'
import EthIcon from 'assets/network-icons/eth-icon.svg?react'
import AVAXIcon from 'assets/network-icons/avax-icon.svg?react'
import PolyIcon from 'assets/network-icons/polygon-icon.svg?react'
import OPIcon from 'assets/network-icons/op-icon.svg?react'
import BaseIcon from 'assets/network-icons/base-icon.svg?react'
import { ArbitrumIcon } from 'components/buttons/wallet-button/styled'
import { TransactionStatus } from 'sdk/omni/omni-transaction-service/types'

const enum LAYER_ZERO_CHAIN_IDS {
  // remove mocks when we have real data
  MOCK_CHAIN = 0,
  ETHEREUM = 101,
  ARBITRUM = 110,
  AVALANCHE = 106,
  BASE = 184,
  POLYGON = 109,
  OPTIMISM = 111,
  //
  TEST_AVAX = 10106,
  TEST_ETHEREUM = 10121,
  TEST_ARBITRUM = 10143,
  TEST_MUMBAI = 10109,
  TEST_SEPOLIA = 10161,
  TEST_SEPOLIA_ARB = 10231,
  TEST_SEPOLIA_OP = 10232,
}

const enum OFFICIAL_CHAIN_IDS {
  ETHEREUM = 1,
  ARBITRUM = 42161,
  AVALANCHE = 43114,
  POLYGON = 137,
  OPTIMISM = 10,
  BASE = 8453,
  //
  TEST_ETHEREUM = 5,
  TEST_ARBITRUM = 421613,
  TEST_MUMBAI = 80001,
  TEST_AVAX = 43113,
  TEST_SEPOLIA = 11155111,
  TEST_SEPOLIA_ARB = 421614,
  TEST_SEPOLIA_OP = 11155420,
}

//here

export const getChainFromLayerZeroChain = (layerZeroChain: number): number => {
  switch (layerZeroChain) {
    case LAYER_ZERO_CHAIN_IDS.MOCK_CHAIN:
    case LAYER_ZERO_CHAIN_IDS.ETHEREUM:
      return OFFICIAL_CHAIN_IDS.ETHEREUM
    case LAYER_ZERO_CHAIN_IDS.ARBITRUM:
      return OFFICIAL_CHAIN_IDS.ARBITRUM
    case LAYER_ZERO_CHAIN_IDS.AVALANCHE:
      return OFFICIAL_CHAIN_IDS.AVALANCHE
    case LAYER_ZERO_CHAIN_IDS.POLYGON:
      return OFFICIAL_CHAIN_IDS.POLYGON
    case LAYER_ZERO_CHAIN_IDS.OPTIMISM:
      return OFFICIAL_CHAIN_IDS.OPTIMISM
    case LAYER_ZERO_CHAIN_IDS.BASE:
      return OFFICIAL_CHAIN_IDS.BASE

    case LAYER_ZERO_CHAIN_IDS.TEST_ETHEREUM:
      return OFFICIAL_CHAIN_IDS.TEST_ETHEREUM
    case LAYER_ZERO_CHAIN_IDS.TEST_ARBITRUM:
      return OFFICIAL_CHAIN_IDS.TEST_ARBITRUM
    case LAYER_ZERO_CHAIN_IDS.TEST_MUMBAI:
      return OFFICIAL_CHAIN_IDS.TEST_MUMBAI
    case LAYER_ZERO_CHAIN_IDS.TEST_AVAX:
      return OFFICIAL_CHAIN_IDS.TEST_AVAX
    case LAYER_ZERO_CHAIN_IDS.TEST_SEPOLIA:
      return OFFICIAL_CHAIN_IDS.TEST_SEPOLIA
    case LAYER_ZERO_CHAIN_IDS.TEST_SEPOLIA_ARB:
      return OFFICIAL_CHAIN_IDS.TEST_SEPOLIA_ARB
    case LAYER_ZERO_CHAIN_IDS.TEST_SEPOLIA_OP:
      return OFFICIAL_CHAIN_IDS.TEST_SEPOLIA_OP

    default:
      throw new Error(`Unknown chain id: ${layerZeroChain}`)
  }
}

/**
 * Provided with a chainId, returns the appropriate badge svg
 * @param chainId
 * @returns
 */
export const getChainBadge = (chainId: number): JSX.Element => {
  switch (chainId) {
    case OFFICIAL_CHAIN_IDS.ETHEREUM:
    case OFFICIAL_CHAIN_IDS.TEST_ETHEREUM:
    case OFFICIAL_CHAIN_IDS.TEST_SEPOLIA:
      return <EthIcon />
    case OFFICIAL_CHAIN_IDS.ARBITRUM:
    case OFFICIAL_CHAIN_IDS.TEST_ARBITRUM:
    case OFFICIAL_CHAIN_IDS.TEST_SEPOLIA_ARB:
      return <ArbitrumIcon />
    case OFFICIAL_CHAIN_IDS.POLYGON:
    case OFFICIAL_CHAIN_IDS.TEST_MUMBAI:
      return <PolyIcon />
    case OFFICIAL_CHAIN_IDS.AVALANCHE:
    case OFFICIAL_CHAIN_IDS.TEST_AVAX:
      return <AVAXIcon />
    case OFFICIAL_CHAIN_IDS.TEST_SEPOLIA_OP:
    case OFFICIAL_CHAIN_IDS.OPTIMISM:
      return <OPIcon />
    case OFFICIAL_CHAIN_IDS.BASE:
      return <BaseIcon />
    default:
      throw new Error(`Unknown chain id: ${chainId}`)
  }
}

export interface MessageProps {
  hash: string
  chainId: number
  status: TransactionStatus
}
